module.exports = __webpack_public_path__ + "static/media/armadilha-edl.11e5ad7d.png";